// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA_bHPBkroNRSITWXQsDMJDfVjTZA9YhXQ",
  authDomain: "shapla-diagnostic-center.firebaseapp.com",
  projectId: "shapla-diagnostic-center",
  storageBucket: "shapla-diagnostic-center.appspot.com",
  messagingSenderId: "591284152986",
  appId: "1:591284152986:web:55a5368f1a4f3df8624d23",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
